export const APPARELS_INFO = {
  hoodies: {
    type: 'apparels',
    subHead: 'Unisex',
    id: 'tu_h',
    displayName: 'Hoodies',
    description: 'Track or cold wear it with confidence',
    path: '/apparels/hoodies',
    sheet_id: '1sc0YUXd8LS8PpOqxZPJHFwPqGLE_wBuGsRGG5jFpuL8',
    sheet_index: 0,
  },
  rhalf: {
    type: 'apparels',
    subHead: 'Unisex',
    id: 'tu_r_hs',
    displayName: 'RoundNeck Half Sleeve',
    description: 'Rounded fitted charisma enabled apparel',
    path: '/apparels/rhalf',
    sheet_id: '1l4dBAXekzYzkoWitVzXcvZgxjfAD7-2cd5jfg9-ixPM',
    sheet_index: 0,
  },
  rfull: {
    type: 'apparels',
    subHead: 'Unisex',
    id: 'tu_r_fs',
    displayName: 'RoundNeck Full Sleeve',
    description: 'Classy perfect color splashed garment',
    path: '/apparels/rfull',
    sheet_id: '1KdO4pgTwUAVCx6lTSFFExDg9KlAIIVjPhnGFpjZzQos',
    sheet_index: 0,
  },
  raglan: {
    type: 'apparels',
    subHead: 'Unisex',
    id: 'tu_rg_fs',
    displayName: 'Raglan Full Sleeve',
    description: 'Get all the perfect rounds & fits',
    path: '/apparels/raglan',
    sheet_id: '1dOO3TkVy-anS058eREOf-L5OVm43hchJ_HFT9pLlgJY',
    sheet_index: 0,
  },
  sweatshirt: {
    type: 'apparels',
    subHead: 'Unisex',
    id: 'tu_s_fs',
    displayName: 'Sweatshirt Full Sleeve',
    description: 'Sweat, Wash & Repeat',
    path: '/apparels/sweatshirt',
    sheet_id: '1knSNQJ7v2QvGNHPLBy-lzAz4RRaQP-WYWvvEjDCiun0',
    sheet_index: 0,
  },
  plain_unisex: {
    type: 'apparels',
    subHead: 'Unisex',
    id: 'tu_pl',
    displayName: 'Plain Unisex',
    description: 'Wear comfy clothes when you fly',
    path: '/apparels/plain_unisex',
    sheet_id: '1SE-5pNdmLio7HhuPxbv0K6wRoV8COUYj-IvrpuSrc80',
    sheet_index: 0,
  },
  vhalf: {
    type: 'apparels',
    subHead: 'Mens',
    id: 'tm_v_hs',
    displayName: 'VNeck Half Sleeve',
    description: 'Bedday or Outdoor, It covers everything',
    path: '/apparels/vhalf',
    sheet_id: '1EIwtrhnqoYUrl6gemJoIlp0AQwiZIrjQLEZD4NRM-t0',
    sheet_index: 0,
  },
  polo: {
    type: 'apparels',
    subHead: 'Mens',
    id: 'tm_p',
    displayName: 'Polo',
    description: 'Gentlemen perfect suits in tee’s',
    path: '/apparels/polo',
    sheet_id: '1-I66XoFrRwi__X653Cee-axkdcnwGJUFiIF1jPqkOGY',
    sheet_index: 0,
  },
  gymvest: {
    type: 'apparels',
    subHead: 'Mens',
    id: 'tm_r_ns',
    displayName: 'Gym Vest',
    description: 'Hit the gym with powerful tee’s',
    path: '/apparels/gymvest',
    sheet_id: '1XE4fqcMQzGiN-9BOdrqsArxpkOlhwRRDMV1XHa5nu2A',
    sheet_index: 0,
  },
  allover_men: {
    type: 'apparels',
    subHead: 'Mens',
    id: 'tm_ao',
    displayName: 'AllOver Print Mens',
    description: 'Let your kraken speak your attitude through prints',
    path: '/apparels/allover_men',
    sheet_id: '1gbyxO7GfEeL0BWvQb1FoOKJa0JNbriCCeAgnjH_YmPo',
    sheet_index: 0,
  },
  plain_mens: {
    type: 'apparels',
    subHead: 'Mens',
    id: 'tm_pl',
    displayName: 'Plain Mens',
    description: 'Turn your life moments into a unique colours',
    path: '/apparels/plain_mens',
    sheet_id: '1lHO9dijiDgqCroCMLRdcWU1M3xMkBzWijb1I5LAHNJw',
    sheet_index: 0,
  },
  ctop: {
    type: 'apparels',
    subHead: 'Womens',
    id: 'tw_ct',
    displayName: 'Crop Top',
    description: 'Freakingly styled trimmed tops',
    path: '/apparels/ctop',
    sheet_id: '17mtMdJjgKdgXHuWM4o5486OTK6lsgaBNiSIaPtWXKsk',
    sheet_index: 0,
  },
  ttop: {
    type: 'apparels',
    subHead: 'Womens',
    id: 'tw_tt',
    displayName: 'Tank Top',
    description: 'Colors should be your concern not the fits & cuts',
    path: '/apparels/ttop',
    sheet_id: '1Nagl30fIJntyb7kNiB0Z6bFzFaxdstHni86AdSwh1UE',
    sheet_index: 0,
  },
  ltop: {
    type: 'apparels',
    subHead: 'Womens',
    id: 'tw_lt',
    displayName: 'Long Top',
    description: 'Party ready outfit, just got out of box',
    path: '/apparels/ltop',
    sheet_id: '13DYdvIYsU5ET9K5lo8C2m8hI6dfjsxNJA4RKfSQ5RGs',
    sheet_index: 0,
  },
  mtop: {
    type: 'apparels',
    subHead: 'Womens',
    id: 'tw_mt',
    displayName: 'Maternity Top',
    description: 'Make your Trimesters comfortable',
    path: '/apparels/mtop',
    sheet_id: '1_2vZ2ofjky7qhXVkEQENPl05l6uzDPXAu59QxjGRZgU',
    sheet_index: 0,
  },
  allover_women: {
    type: 'apparels',
    subHead: 'Womens',
    id: 'tw_ao',
    displayName: 'AllOver Print Womens',
    description: 'Prints that unleash your soul',
    path: '/apparels/allover_women',
    sheet_id: '1la60zLNcOepFLlHQRILqCax4RhhxlHdj6SV-ycrpzJk',
    sheet_index: 0,
  },
  plain_womens: {
    type: 'apparels',
    subHead: 'Womens',
    id: 'tw_pl',
    displayName: 'Plain Womens',
    description: 'Like my outfit? Gee Thanks!, Just bought it',
    path: '/apparels/plain_womens',
    sheet_id: '1KLltjAoNPOA02qnacvB0yXo2289ImZPArZZmxPxThsg',
    sheet_index: 0,
  },
  rompers: {
    type: 'apparels',
    subHead: 'Kids',
    id: 'tk_rp',
    displayName: 'Rompers',
    description: 'Style your Champs with customized clothes',
    path: '/apparels/rompers',
    sheet_id: '1XSz3eLJvZ1GRnR6ZjLw43rxn1ChKVqQpXFjzGP_Q2k8',
    sheet_index: 0,
  },
  rhalf_boy: {
    type: 'apparels',
    subHead: 'Kids',
    id: 'tk_b_r',
    displayName: 'RoundNeck Boys',
    description: 'Cool & Classy right fitted apparel',
    path: '/apparels/rhalf_boy',
    sheet_id: '1X4To1h5CdNyIkkFkfliKLL0uF6rzX7G8_feNkYngYTY',
    sheet_index: 0,
  },
  rhalf_girl: {
    type: 'apparels',
    subHead: 'Kids',
    id: 'tk_g_r',
    displayName: 'RoundNeck Girls',
    description: 'Floral & Funky delicate garment',
    path: '/apparels/rhalf_girl',
    sheet_id: '1786_z_ZwcOFWzL1kOtTaiu8Cpjxhqe9lv6BdTiUHIQM',
    sheet_index: 0,
  },
  hoodies_kids: {
    type: 'apparels',
    subHead: 'Kids',
    id: 'tk_h',
    displayName: 'Hoodies Kids',
    description: 'Make your kid a Superhero',
    path: '/apparels/hoodies_kids',
    sheet_id: '1Hn9Wt6ny7mFnyK59hvLyubP-CDjGE8wELjAWVEbUdDE',
    sheet_index: 0,
  },
  plain_kids: {
    type: 'apparels',
    subHead: 'Kids',
    id: 'tk_pl',
    displayName: 'Plain Kids',
    description: 'Just feel like your\'re home',
    path: '/apparels/plain_kids',
    sheet_id: '1ziYwn5m39dGI6h-zVzVBSX0y5JmcWfSTWFOlC8m40WU',
    sheet_index: 0,
  },
};

export const ACCESSORIES_INFO = {
  badge: {
    type: 'accessories',
    id: 'a_b',
    displayName: 'Badge',
    description: 'Start your day with badass circles',
    path: '/accessories/badge',
    sheet_id: '1d9Qm-PSf5J62GHRxml6Dd842KPWeObvVRVD0tv3E9qQ',
    sheet_index: 0,
  },
  coaster: {
    type: 'accessories',
    id: 'a_c',
    displayName: 'Coaster',
    description: 'Mug’s perfect Stylish partner',
    path: '/accessories/coaster',
    sheet_id: '1zEqolvTpJ50XOhuJumCgmmIDMmdPVHShT6xZwb3l-j4',
    sheet_index: 0,
  },
  mobilecase: {
    type: 'accessories',
    id: 'a_mc',
    displayName: 'Mobile Case',
    description: 'Protection with funky collections',
    path: '/accessories/mobilecase',
    sheet_id: '1-yrc31GcixtG2tjJ_y6WjqmJKbJLFDebEJnPq04vEdM',
    sheet_index: 0,
  },
  mousepad: {
    type: 'accessories',
    id: 'a_mp',
    displayName: 'Mouse Pad',
    description: 'Swipe through soft patterned pads',
    path: '/accessories/mousepad',
    sheet_id: '1qUl14CpWwBe2fysqdS6Vt28yd6Uk9mfWuZVQwdA5oT8',
    sheet_index: 0,
  },
  mug: {
    type: 'accessories',
    id: 'a_m',
    displayName: 'Mug',
    description: 'Ceramic well with themed will',
    path: '/accessories/mug',
    sheet_id: '1v7nUReteAXuMpyXY8hLeDunlciQP4jUbk_Jk5-N5POk',
    sheet_index: 0,
  },
  notepad: {
    type: 'accessories',
    id: 'a_np',
    displayName: 'Notepad',
    description: 'Memories with Vogue',
    path: '/accessories/notepad',
    sheet_id: '1QTlbqvGZJO4wz-Sc86mXHpkbnB5fPyBn7cfljI5PBDg',
    sheet_index: 0,
  },
  popgrip: {
    type: 'accessories',
    id: 'a_pg',
    displayName: 'Pop Grip',
    description: 'Grab your mobile with some Trend',
    path: '/accessories/popgrip',
    sheet_id: '1oBQ9KS3qOmo224oAO0k1BLu1M-H8FkoEMKt1N0ut0L4',
    sheet_index: 0,
  },
  sipperbottle: {
    type: 'accessories',
    id: 'a_sb',
    displayName: 'Sipper Bottle',
    description: 'Get Energified with your Superheroes',
    path: '/accessories/sipperbottle',
    sheet_id: '1RWihBT5lC61j2WC5cDQFzNnKuN87ZALXb8QMONI-7f8',
    sheet_index: 0,
  },
  totebag: {
    type: 'accessories',
    id: 'a_tb',
    displayName: 'Tote Bag',
    description: 'Carry around with Fashion',
    path: '/accessories/totebag',
    sheet_id: '1myTFkdI0Du6jVxNol0Jpmjlc72IIuQ7t7uadzWtw9rE',
    sheet_index: 0,
  },
};

export const DECORS_INFO = {
  canvas: {
    type: 'decors',
    id: 'd_c',
    displayName: 'Canvas',
    description: 'Throw some colors to the wall',
    path: '/decors/canvas',
    sheet_id: '1SdOjv2FrUz3xDUSCmhctDHwFoDTwnuXms1dr4vb3MgE',
    sheet_index: 0,
  },
  photoframe: {
    type: 'decors',
    id: 'd_pf',
    displayName: 'Photo Frame',
    description: 'Just capture & we’ll cover it',
    path: '/decors/photoframe',
    sheet_id: '1IXvxAoQIsVGlBEhS743YBP4JqfPw0-SxEf61KVqnG2A',
    sheet_index: 0,
  },
  poster: {
    type: 'decors',
    id: 'd_p',
    displayName: 'Poster',
    description: 'All time wall Coverer',
    path: '/decors/poster',
    sheet_id: '1CennVkxKuEV459NcU59S9rcFsLPyeMWVboJU7s5gj58',
    sheet_index: 0,
  },
  // dreamcatcher: {
  //   type: 'decors',
  //   id: 'd_dc',
  //   displayName: 'Dream Catcher',
  //   description: 'Splash some feathers to your spot',
  //   path: '/decors/dreamcatcher',
  //   sheet_id: '1R50zCCVpnlEXM_QHEl0Po2_mq6XmFcD4h8cfwSvqyCM',
  //   sheet_index: 0,
  // },
};

export const GOOGLE_SHEETS_AUTH = {
  type: 'service_account',
  project_id: 'bienes-mart',
  private_key_id: process.env.REACT_APP_GS_KEY_ID,
  private_key:
    '-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCK64FxnKBUnGSY\nfdfuUFn6KeSDdVKAcRtNN6ZKW3IrRZgSmkBn49UVJNp1Uw6ImKQion8JSLQcJWoz\nseJJgtjrIjdE9suDB+ETkkVHGx+O1acUwaXdqBlChQiTQFIFOmLnmaxLZQN/Kv4G\n3UZtd3U1ROQotNPwR6Wv7tmDwurKeHIe9KtpZ+PVzB55y9PRc7/Ly5+dDlRWUfbm\nOz8PvmRLh9KwHrZQM47aPedvAO3Mx5P3wCXNSwovT7aft0UfmMyp+cxHSxUjMCfb\nYQnp4Qg4yfEFIwBDpi3UBmpBXh6qg1yA9CoeOuArYrxfG1RdDgLOtTtIZSk8K6lz\nIacwR+UjAgMBAAECggEAAmPH9HouSky6cK+Et57+o6gO1bGx+29DefhhtIvBxghk\nQLje/MQiYtyHoyPZO/S5D7aqtGOUymf2XYp+cXQXyTIe40fSyAYQ4CZQnMchq6WP\nQnMmW4H/YgtdBc0O3Cb2xppewjLfQYb6zofSvoiJWQlxwPJQM9gq4hqCXjR/MRmk\n1uA2zxQChPQ34gPR+vMY4TPUiWbjxPhz/r94I7kwbWAnBLGwiapHtzpHyr+zpWJ2\nseG06zB1OmbLdeFjHwq42Q4ByLX4SRez+1rgsrV4RxYcuScHhBTQ0+hLZ64aH78U\nxDcbGvS80nusGCmJmaBa2exRX55zfte+52gGCFraIQKBgQDDbSYa9XFKallDW2LF\nMsFZcstaSBxSZa/JcC3T2CGYAm+ceJnI084ASmQSw8iugTeWjwtcxaE7pSdLVx+x\nuB0qu7xEhCdJPk9zMHHnAcefIGYVss6PIQ9FdnYCjZxAnMr4RCJY8X6IYHeXo/uK\nc5EXb8yr3oR7J1TvySvWs5RdcwKBgQC1+qOg6tp9C0aF9aaA7zLet9iu9UBmJ86C\nefGDvhmnJQpRAC4iRHzb1RvEikXrCDvRu6HY8tLP19s/CHTVYm6fqknIiqeuIjCG\n7CKrYSKtlwHZw0kp5oWgIP/H2ZAjTJ4pcx5brJEosYKyJJ07OpAFa7jmFAoGwQpI\nUiVDb3dtkQKBgCN2BtgVeX07Vv818fI+h38nqWa0dw8sjH1M8cPjEBV5O6904tLi\nPBspZIdTJ3Mi12dmhXVMFzmvejXdlU62TfSXJE56fHZ57AjG3aRBWmuxgVSmoXyv\nTwoXuMo10AiZausp0eG50HAGsSy/AMHavpU2IDl/oyKFvI/WPTI0W9OpAoGACFPS\n3w9ANk6oyIKIPwgzJLv2/3KbotEZgyD/a07sr5hjU3eVpN3LdOfYoHLPZkT3L87N\nRjc+bGJtVwIVDpq1gzrwq2uk5rQL0nDF2V/VjWoGnKdyFqfE36IC8mtDTEo6Rp1M\n+1b3QYx19Z71TvuMEaNvT6AFIW/9/3c6204jgfECgYEAiryR5HAE9YQEcBDKrAox\n5+6mOtcpDFLylowULOqodByyIXyE6dC61zt8g19s+5tT79JZlCwBtU52aVDNDM/v\nf7GK4vSnpY/xMyXGsx+TnDgQqtNV3pJacvJxz7JHiCt7axCKh0Fbt1W7+YDSM0B6\n03ZY0SnXyIaFu3wuoccsYsY=\n-----END PRIVATE KEY-----\n',
  client_email: process.env.REACT_APP_GS_C_EMAIL,
  client_id: process.env.REACT_APP_GS_C_ID,
  auth_uri: 'https://accounts.google.com/o/oauth2/auth',
  token_uri: 'https://oauth2.googleapis.com/token',
  auth_provider_x509_cert_url: 'https://www.googleapis.com/oauth2/v1/certs',
  client_x509_cert_url:
    'https://www.googleapis.com/robot/v1/metadata/x509/google-sheets-api%40bienes-mart.iam.gserviceaccount.com',
};
